import { Toaster } from "@/components/ui/sonner";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import PublicLayout from "@/components/Layout/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Cart from "@/pages/Cart";
import PatientConsent from "@/pages/PatientConsent";
import CompleteProfile from "@/pages/CompleteProfile";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardIndex from "@/pages/dashboard/DashboardIndex";
import VerificationPage from "@/pages/dashboard/VerificationPage";
import AdminVerifications from "@/pages/dashboard/AdminVerifications";
import AdminProducts from "@/pages/dashboard/AdminProducts";
import AdminOrders from "@/pages/dashboard/AdminOrders";
import AdminUsers from "@/pages/dashboard/AdminUsers";
import AdminSettings from "@/pages/dashboard/AdminSettings";
import AdminCategories from "@/pages/dashboard/AdminCategories";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { CategoriesProvider } from "@/contexts/CategoriesContext";

const ADMIN_ROLES = ["admin"];

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <LanguageProvider>
          <CategoriesProvider>
            <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/complete-profile" element={<CompleteProfile />} />
              <Route path="/patient-consent" element={<PatientConsent />} />
              {/* Legacy redirects */}
              <Route path="/doctor-register" element={<Navigate to="/register" replace />} />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardIndex />} />
                <Route path="verification" element={<VerificationPage />} />
                {/* Legacy redirect for old /dashboard/prescription bookmarks */}
                <Route path="prescription" element={<Navigate to="/dashboard/verification" replace />} />
                <Route path="verifications" element={
                  <ProtectedRoute roles={ADMIN_ROLES}><AdminVerifications /></ProtectedRoute>
                } />
                <Route path="categories" element={
                  <ProtectedRoute roles={ADMIN_ROLES}><AdminCategories /></ProtectedRoute>
                } />
                <Route path="products" element={
                  <ProtectedRoute roles={ADMIN_ROLES}><AdminProducts /></ProtectedRoute>
                } />
                <Route path="orders" element={
                  <ProtectedRoute roles={ADMIN_ROLES}><AdminOrders /></ProtectedRoute>
                } />
                <Route path="users" element={
                  <ProtectedRoute roles={ADMIN_ROLES}><AdminUsers /></ProtectedRoute>
                } />
                <Route path="settings" element={
                  <ProtectedRoute roles={ADMIN_ROLES}><AdminSettings /></ProtectedRoute>
                } />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
          </CartProvider>
          </CategoriesProvider>
        </LanguageProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
